module.exports = __webpack_public_path__ + "img/hero.b63e10cc.png";